import {mainQuery} from '@github-ui/react-core/future/main-query'

import {reposListAppBuilder} from '../config/app-builder'
import type {PagePayload} from '../types/repos-list-types'

export const repositoriesPageRoute = reposListAppBuilder.createQueryRouteConfig('repositoriesPageRoute', {
  path: '/orgs/:org/repositories',
  queries: [mainQuery<PagePayload>()],
})
